import Vue from 'vue';
import Component from 'vue-class-component';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');
import banksData from './data/banks.json';
import { QIcon, Notify } from 'quasar-framework/dist/quasar.mat.esm';

const banks = banksData.banks;

@WithRender
@Component({
    components: {
        'q-icon': QIcon
    }
})
export class SbpModalComponent extends Vue {
    opened = false;
    search = '';
    qrUrl = '';
    errorText = '';
    showBankCount = 8;
    attemptsToSelect = 0;
    
    get filteredBanks() {
        if (!this.search) {
            return banks.slice(0, this.showBankCount);
        }
        
        return banks
            .filter(bank => {
                return bank.bankName.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            })
            .slice(0, this.showBankCount);
    }

    getRedirectUrl(bank) {
        const param = new URLSearchParams(this.qrUrl).get('data');

        if (!param) {
            this.errorText = 'К сожалению, произошла ошибка. Пожалуйста, выберите другой способ оплаты.';
            
            return '';
        }
        
        return param.replace(/https|http/, bank.schema);
    }
    
    show(qrUrl: string) {
        this.errorText = '';
        this.qrUrl = qrUrl;
        this.opened = true;
    }
    
    close() {
        this.errorText = '';
        this.$emit('close');
        this.opened = false;
    }

    onSelectBank(bank) {
        this.attemptsToSelect += 1;
        if (this.attemptsToSelect > 2) {
            Notify.create({
                message: 'Если переход в приложение банка не происходит, проверьте, доступно ли оно на вашем устройстве.',
                timeout: 3000,
                color: 'primary'
            });
            this.attemptsToSelect = 0;
        }

        document.location.href = this.getRedirectUrl(bank);
    }
}
